// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1ULVd","buttons":"RemoveExpirationActionButtons_buttons__3YO41"};